export enum SkeletonLoaderTemplate {
    WEB_ORDERING_STORES,
    WHITELABEL_STORES,
    MENU,
    CHECKOUT,
    PAYMENT_SUCCESS,
    PAYMENT_FAILURE,
    PERSONAL_SETTINGS,
    MY_ADDRESSES,
    MY_ALLERGIES,
    LOYALTY,
    ORDER_HISTORY,
    ORDER_PREVIEW,
    MY_PAYMENTS
}